var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamsSettingsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Streams_Settings_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Streams_Settings_Normal",
    "data-name": "Streams Settings_Normal",
    clipPath: "url(#clip-Streams_Settings_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Streams_Settings",
    "data-name": "Streams Settings",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_49",
    "data-name": "Subtraction 49",
    d: "M-1667.217-582.823h-2.445a1.156,1.156,0,0,1-1.145-1.073l-.057-.915a7.325,7.325,0,0,1-1.2-.5l-.7.6a1.18,1.18,0,0,1-.759.271,1.132,1.132,0,0,1-.815-.343l-1.731-1.731a1.153,1.153,0,0,1-.057-1.572l.6-.687a8.026,8.026,0,0,1-.5-1.216l-.915-.071a1.162,1.162,0,0,1-1.058-1.158v-2.445a1.156,1.156,0,0,1,1.073-1.145l.915-.057a7.322,7.322,0,0,1,.5-1.2l-.6-.7a1.156,1.156,0,0,1,.058-1.573l1.731-1.731a1.191,1.191,0,0,1,.815-.328,1.164,1.164,0,0,1,.759.285l.686.6a8.005,8.005,0,0,1,1.216-.5l.071-.915a1.14,1.14,0,0,1,1.144-1.073l.014.014h2.445a1.156,1.156,0,0,1,1.145,1.073l.057.915a7.331,7.331,0,0,1,1.2.5l.7-.6a1.176,1.176,0,0,1,.758-.272,1.133,1.133,0,0,1,.814.344l1.731,1.73a1.156,1.156,0,0,1,.058,1.573l-.6.687a8,8,0,0,1,.5,1.216l.915.071a1.162,1.162,0,0,1,1.058,1.158v2.445A1.154,1.154,0,0,1-1659.91-590l-.915.058a7.335,7.335,0,0,1-.5,1.2l.6.7a1.155,1.155,0,0,1-.058,1.573l-.872.859-.872.858a1.179,1.179,0,0,1-.815.328,1.16,1.16,0,0,1-.758-.285l-.687-.6a8.006,8.006,0,0,1-1.216.5l-.071.915A1.14,1.14,0,0,1-1667.217-582.823Zm-1.232-13.828a4.231,4.231,0,0,0-2.974,1.229,4.205,4.205,0,0,0-1.244,2.989,4.193,4.193,0,0,0,1.23,2.989,4.2,4.2,0,0,0,2.988,1.245h.014a4.229,4.229,0,0,0,2.974-1.23,4.2,4.2,0,0,0,1.245-2.989,4.2,4.2,0,0,0-1.23-2.99,4.208,4.208,0,0,0-2.989-1.243Z",
    transform: "translate(1683.477 607.263)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    "data-name": "Group 2188",
    transform: "translate(1.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4790",
    "data-name": "Path 4790",
    d: "M33.458,16.218a.585.585,0,0,1-.549-.386A13.742,13.742,0,0,0,8.095,13.8a.588.588,0,0,1-.795.215.575.575,0,0,1-.217-.787,14.911,14.911,0,0,1,26.924,2.2.576.576,0,0,1-.347.744.5.5,0,0,1-.2.029Z",
    transform: "translate(-7.008 -5.718)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4791",
    "data-name": "Path 4791",
    d: "M23.99,12.924l2.531,2.5.9-3.446Z",
    transform: "translate(0.579 -3.025)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    "data-name": "Group 2189",
    transform: "translate(0 17.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4792",
    "data-name": "Path 4792",
    d: "M20.215,29.47a15.667,15.667,0,0,1-2.445-.2A14.668,14.668,0,0,1,6.329,19.588a.574.574,0,0,1,1.087-.372A13.568,13.568,0,0,0,25.177,27.4a.575.575,0,1,1,.415,1.073,14.7,14.7,0,0,1-5.363,1.015Z",
    transform: "translate(-5.314 -16.9)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4793",
    "data-name": "Path 4793",
    d: "M9.056,20.011l-2.5-2.531L5.61,20.926Z",
    transform: "translate(-5.61 -17.48)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4794",
    "data-name": "Path 4794",
    d: "M21.463,25.326a.572.572,0,0,1-.3-1.058,9.389,9.389,0,0,0,1.044-.729.58.58,0,1,1,.729.9,12.313,12.313,0,0,1-1.158.8.6.6,0,0,1-.3.086Z",
    transform: "translate(1.186 2.172)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4795",
    "data-name": "Path 4795",
    d: "M23.712,23.925a.529.529,0,0,1-.372-.143.571.571,0,0,1-.057-.815,13.194,13.194,0,0,0,1.673-2.474.572.572,0,0,1,1.015.529,14.791,14.791,0,0,1-1.816,2.689.586.586,0,0,1-.443.2Z",
    transform: "translate(2.212 0.73)",
    fill: "#6f8b8f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamsSettingsNormal);
export default __webpack_public_path__ + "static/media/Streams_Settings_Normal.66bb68c2afa832468cd517095cb3469c.svg";
export { ForwardRef as ReactComponent };